<template>
  <div>
    <md-card class="custom">
      <div class="md-layout ">
        <div class="md-layout-item md-size-100">
          <div
            class="md-layout "
            v-for="field in orderedFields"
            :key="field.value"
          >
            <div
              class="md-layout-item md-size-25 label md-caption line"
              v-if="field.Label"
            >
              {{ field.Label }}
            </div>
            <div
              class="md-layout-item md-size-75 bold label line pl-30"
              v-if="field.Label"
            >
              {{ field.value }}
            </div>
            <div
              class="md-layout-item md-size-100 label prova-w line"
              v-if="!field.Label"
            >
              {{ field.value }}
            </div>
          </div>
        </div>
      </div>
    </md-card>
  </div>
</template>

<script>
export default {
  mounted() {},
  data: function() {
    return {};
  },
  props: ["profile"],
  methods: {},
  computed: {
    orderedFields() {
      var tempOrderedFields = [];
      this.profile.Message.forEach(message => {
        message.content.forEach(content => {
          var contentFields = content.Fields.sort((a, b) => {
            return a.DisplayOrder > b.DisplayOrder ? 1 : -1;
          }).filter(field => {
            return field.DisplayInVoting === true;
          });
          tempOrderedFields = tempOrderedFields.concat(contentFields);
        });
      });
      return tempOrderedFields;
    }
  }
};
</script>
<style scoped>
.label {
  padding: 10px 20px;
}
.custom {
  padding: 0 10px;
}

.md-theme-default .md-card {
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0), 0 0px 0px 0 rgba(0, 0, 0, 0),
    0 0px 0px 0 rgba(0, 0, 0, 0) !important;
  position: relative;
  z-index: 1;
  border-radius: 2px;
  transition: 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  transition-property: all;
  transition-property: color, background-color;
  will-change: color, background-color;
}

.md-card {
  box-shadow: none !important;
  font-size: 18px !important;
  position: relative;
  z-index: 1;
  border-radius: 2px;
  transition: 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  transition-property: all;
  transition-property: color, background-color;
  will-change: color, background-color;
}

.md-caption {
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0.02em;
  line-height: 18px;
  color: #000 !important;
}

.line {
  border-bottom: 1px solid #dedede !important;
}

@media screen and (max-width: 360px) {
  .pl-30 {
    padding-left: 30px;
  }
}
</style>
